const PermissionsStyles = {
  dialogPaper: {
    borderRadius: '12px',
    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden',
    width: '90%',
    maxWidth: '600px'
  },
  
  dialogPaperLarge: {
    borderRadius: '12px',
    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden'
  },
  
  dialogTitle: {
    padding: '24px',
    backgroundColor: 'white',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    direction: 'rtl',
    gap: 2
  },
  
  dialogTitleText: {
    fontWeight: 600,
    color: '#000000',
    textAlign: 'right'
  },
  
  dialogContent: {
    padding: '32px 40px',
    backgroundColor: 'white',
    '&:first-of-type': { paddingTop: '32px' }
  },
  
  dialogActions: {
    justifyContent: 'space-between',
    padding: '16px 40px',
    backgroundColor: '#f5f7fa',
    borderTop: '1px solid #e0e0e0'
  },
  
  icon: {
    color: '#1976d2',
    fontSize: 28
  },
  
  gridColumn: {
    direction: 'column',
    spacing: 3
  },
  
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '&:hover fieldset': {
        borderColor: '#1976d2',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
        borderWidth: '1px',
      }
    }
  },
  
  textFieldError: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '&:hover fieldset': {
        borderColor: '#d32f2f',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#d32f2f',
        borderWidth: '1px',
      }
    }
  },
  
  selectMenu: {
    borderRadius: '8px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#c4c4c4',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976d2',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976d2',
      borderWidth: '1px',
    }
  },
  
  menuItem: {
    direction: 'rtl'
  },
  
  menuItemSelectAll: {
    direction: 'rtl',
    borderBottom: '1px solid #eee',
    fontWeight: 'bold',
    color: '#1976d2'
  },
  
  menuProps: {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 250,
      },
    },
  },
  
  menuPropsLarge: {
    PaperProps: {
      style: {
        maxHeight: 48 * 5.5 + 8,
        width: 250,
      },
    },
  },
  
  chip: {
    bgcolor: '#e8f4fd',
    color: '#1976d2',
    fontWeight: 500
  },
  
  chipBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0.5
  },
  
  buttonOutlined: {
    borderRadius: '8px',
    px: 4,
    py: 1,
    border: '1px solid #1976d2',
    color: '#1976d2',
    fontSize: '0.9rem',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.04)',
      borderColor: '#1565c0',
    }
  },
  
  buttonContained: {
    borderRadius: '8px',
    px: 5,
    py: 1,
    fontSize: '0.9rem',
    backgroundColor: '#1976d2',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
    '&.Mui-disabled': {
      backgroundColor: '#e0e0e0',
      color: '#9e9e9e',
    }
  },
  
  checkbox: {
    '&.Mui-checked': {
      color: '#1976d2',
    }
  },
  
  checkboxIndeterminate: {
    '&.Mui-checked': {
      color: '#1976d2',
    },
    '&.MuiCheckbox-indeterminate': {
      color: '#1976d2',
    }
  },
  
  caption: {
    textAlign: 'left',
    display: 'block',
    marginTop: '0.25rem',
    color: '#666',
    direction: 'ltr'
  },
  
  placeholderText: {
    color: '#9ca3af'
  },
  
  containerLarge: {
    width: '90vw',
    maxWidth: '900px'
  },
  
  rtlText: 'text-right',
  rtlDir: 'rtl'
};

export default PermissionsStyles;